import { ScopeCollector } from "@frontend/common/scope-collector";

export const ShowPageScopeCollector = new ScopeCollector()